// @flow
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBook,
  faCheck,
  faVideo,
  faTags,
  faArrowRight,
  faNewspaper,
  faGraduationCap,
  faVolumeUp,
  faMobileAlt,
  faLaptop,
  faFileAlt,
  faPlay,
  faFileDownload,
  faPrint
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faBook,
  faCheck,
  faVideo,
  faTags,
  faArrowRight,
  faNewspaper,
  faGraduationCap,
  faVolumeUp,
  faMobileAlt,
  faLaptop,
  faFileAlt,
  faPlay,
  faFileDownload,
  faPrint
);



// WEBPACK FOOTER //
// ./src/components/icons/FontAwesome.js